import React from 'react'

const ItemQuestion = props => {
  const { question, answer } = props.item
  return (
    <div className='mt-5 mb-5'>
      <div className='row'>
        <div className='col'>
          <h5 className='font-weight-bold'>{question}</h5>
        </div>
      </div>
      <div className='row'>
        <div className='col'>
          <p className='text-justify'>{answer}</p>
        </div>
      </div>
    </div>
  )
}

export default ItemQuestion
